import src from "IMAGE";
export default { src, width: 815, height: 130, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJklEQVR42mMI85PvdLaVqhUQ4KsXEuLvBuJefn7eciCu5OfnKQEAdGAGc9G9cikAAAAASUVORK5CYII="};
